import { TableCell, TableSortLabel } from '@mui/material'
import React from 'react'

interface SortableTableCellProps {
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right'
  onChangeSortByDirection: (propertyName: string) => void
  propertyName: string
  sortBy?: string
  sortDirection?: 'asc' | 'desc'
}

//  Summary
//    The SortableTableCell is used for table headers where columns can be sorted ascending or descending.
export default function SortableTableCell({
  align,
  children,
  onChangeSortByDirection,
  propertyName,
  sortBy,
  sortDirection
}: React.PropsWithChildren<SortableTableCellProps>) {
  return (
    <TableCell
      align={align}
      sortDirection={sortBy === propertyName ? sortDirection : false}
      sx={theme => ({ color: theme.palette.primary.main })}
    >
      <TableSortLabel
        active={sortBy === propertyName}
        direction={sortBy === propertyName ? sortDirection : undefined}
        onClick={() => {
          onChangeSortByDirection(propertyName)
        }}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  )
}
